module.exports = __webpack_public_path__ + "static/media/GA-320.ef81c80f.png";